import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const OwnedMediaDevice11: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 313.88" {...props}>
    <defs>
      <clipPath id="owned1-1_svg__clip-path" transform="translate(-10.66)">
        <path fill="none" d="M0 157.56h160.26v121.65H0z" />
      </clipPath>
      <style>{'.owned1-1_svg__cls-5{fill:#eee}.owned1-1_svg__cls-6{fill:#a0a0a0}'}</style>
    </defs>
    <g id="owned1-1_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="owned1-1_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          d="M134.63 7.33H120.5v1.92a7.58 7.58 0 01-7.58 7.59H53.8a7.59 7.59 0 01-7.59-7.59V7.33h-15a14.31 14.31 0 00-14.27 14.31v257.6a14.31 14.31 0 0014.31 14.31h103.38a14.31 14.31 0 0014.3-14.31V21.64a14.31 14.31 0 00-14.3-14.31z"
          transform="translate(-10.66)"
          fill="#fff"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path fill="#424242" d="M6.33 23.04H138.3v131.97H6.33z" />
        <g clipPath="url(#owned1-1_svg__clip-path)">
          <path
            className="owned1-1_svg__cls-5"
            d="M10.54 205.7h34.5v3.94h-34.5zM10.55 199.69h55.43v4.21H10.55zM73.58 205.7h34.5v3.94h-34.5zM73.59 199.69h55.43v4.21H73.59z"
          />
          <path
            className="owned1-1_svg__cls-6"
            d="M10.37 161.51h57.88v32.08H10.37zM10.37 232h121.04v42.71H10.37zM73.41 161.51h57.88v32.08H73.41z"
          />
          <path stroke="#f5f5f5" strokeMiterlimit={10} fill="none" d="M7.22 220.6h130.47" />
          <path
            className="owned1-1_svg__cls-5"
            d="M9.93 309.94h8.63v3.94H9.93zM9.93 279.99h122.61v4.21H9.93zM9.93 300.19h122.61v4.21H9.93zM9.93 289.54h117.91v4.21H9.93z"
          />
        </g>
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();
export default OwnedMediaDevice11;
